import React from 'react'
import { Box, IconButton, Tooltip } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { advancedColors } from '../theme'

const stopAccordionKey = (event: React.KeyboardEvent) => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.stopPropagation()
  }
}

const CardHelp = ({ title, children }: { title: string; children: string }) => (
  <Box
    component="span"
    sx={{ display: 'inline-flex', ml: 0.75, transform: 'translateY(1px)' }}
    // Help interactions must not toggle the surrounding accordion.
    onClick={(event) => event.stopPropagation()}
    onKeyDown={stopAccordionKey}
    onKeyUp={stopAccordionKey}
    onFocus={(event) => event.stopPropagation()}
  >
    <Tooltip title={children} describeChild>
      <IconButton size="small" aria-label={`About ${title}`} sx={{ color: advancedColors.ink, p: 0.25 }}>
        <InfoOutlinedIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  </Box>
)

export default CardHelp
